export enum AddendumStatus {
  DRAFT = 'DRAFT',
  AWAIT_COMPANY = 'AWAIT_COMPANY',
  AWAIT_AGENT = 'AWAIT_AGENT',
  ACTIVE = 'ACTIVE',
  TERMINATED = 'TERMINATED ',
  CLOSED = 'CLOSED',
}
